/**
 * Equalizes swatch widths without replacing existing values when the buttons cannot be measured.
 * @param {Iterable<HTMLElement>} items
 * @param {boolean} [excludeSwatchWidth=false]
 * @returns {void}
 */
export const setUniformSwatchWidths = (items, excludeSwatchWidth = false) => {
  if (excludeSwatchWidth) {
    return;
  }

  const buttons = [...items];
  const previousWidths = buttons.map(button => button.style.width);
  buttons.forEach(button => {
    button.style.width = 'auto';
  });

  const widestWidth = buttons.reduce((width, button) => Math.max(width, button.getBoundingClientRect().width), 0);
  if (!Number.isFinite(widestWidth) || widestWidth <= 0) {
    buttons.forEach((button, index) => {
      button.style.width = previousWidths[index];
    });
    return;
  }

  const uniformWidth = `${Math.ceil(widestWidth)}px`;
  buttons.forEach(button => {
    button.style.width = uniformWidth;
  });
};
